import { render, staticRenderFns } from "./MessageEditConvoSubject.vue?vue&type=template&id=565e5f71&scoped=true"
import script from "./MessageEditConvoSubject.vue?vue&type=script&lang=js"
export * from "./MessageEditConvoSubject.vue?vue&type=script&lang=js"
import style0 from "./MessageEditConvoSubject.vue?vue&type=style&index=0&id=565e5f71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565e5f71",
  null
  
)

export default component.exports